import apiSlice from "../../store/apis/apiSlice";

export const mailerApiSlice = apiSlice.injectEndpoints({
  TAGS: ["MAIL", "TEMPLATE_FOLDERS"],

  endpoints: (builder) => ({
    getAllEmailTemplates: builder.query({
      query: (folder_name) => ({
        url: `/fetch-all-email-templates/${folder_name}`,
        method: "GET",
      }),
      providesTags: ["MAIL"],
    }),

    getAllEmailTemplateFolders: builder.query({
      query: () => ({
        url: "/fetch-all-email-template-folders",
        method: "GET",
      }),
      providesTags: ["TEMPLATE_FOLDERS"],
    }),

    saveEmailTemplate: builder.mutation({
      query: (data) => ({
        url: `/add-email-template`,
        method: "POST",
        body: { ...data },
      }),
      invalidatesTags: ["MAIL"],
    }),

    moveEmailTemplate: builder.mutation({
      query: (data) => ({
        url: `/move-template`,
        method: "POST",
        body: { ...data },
      }),
      invalidatesTags: ["MAIL"],
    }),

    saveEmailTemplateFolder: builder.mutation({
      query: (data) => ({
        url: `/create-folder`,
        method: "POST",
        body: { ...data },
      }),
      invalidatesTags: ["TEMPLATE_FOLDERS"],
    }),

    getSingleEmailTemplateFolder: builder.query({
      query: (id) => ({
        url: `/edit-folder/${id}`,
        method: "GET",
      }),
    }),

    updateEmailTemplateFolder: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `/update-folder/${id}`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["TEMPLATE_FOLDERS"],
    }),

    getSingleEmailTemplate: builder.query({
      query: (id) => ({
        url: `/get-single-email-template/${id}`,
        method: "GET",
      }),
    }),

    updateEmailTemplate: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `/update-email-template/${id}`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["MAIL"],
    }),

    deleteEmailTemplate: builder.mutation({
      query: (id) => {
        return {
          url: `/delete-email-template/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["MAIL"],
    }),

    deleteEmailTemplateFolder: builder.mutation({
      query: (id) => {
        return {
          url: `/delete-folder/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["TEMPLATE_FOLDERS"],
    }),

    uploadImage: builder.mutation({
      query: (body) => ({
        url: `/upload-image-for-email-template`,
        method: "POST",
        body,
      }),
    }),

    getSiteInfo: builder.query({
      query: () => "/fetch-site-info",
    }),
    duplicateEmailTemplate: builder.mutation({
      query: (id) => ({
        url: `/duplicate-email-template/${id}`,
        method: "POST",
      }),
      invalidatesTags: ["MAIL"],
    }),
    getAllSignatures: builder.query({
      query: () => "/fetch-my-signatures",
    }),
    testEmail: builder.mutation({
      query: (body) => ({
        url: "/test-email",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useSaveEmailTemplateMutation,
  useSaveEmailTemplateFolderMutation,
  useMoveEmailTemplateMutation,
  useLazyGetSingleEmailTemplateFolderQuery,
  useUpdateEmailTemplateFolderMutation,
  useLazyGetSingleEmailTemplateQuery,
  useUpdateEmailTemplateMutation,
  useUploadImageMutation,
  useLazyGetAllEmailTemplatesQuery,
  useDeleteEmailTemplateMutation,
  useDeleteEmailTemplateFolderMutation,
  useLazyGetSiteInfoQuery,
  useGetAllEmailTemplatesQuery,
  useGetAllEmailTemplateFoldersQuery,
  useDuplicateEmailTemplateMutation,
  useGetAllSignaturesQuery,
  useTestEmailMutation,
} = mailerApiSlice;
